module.exports = __webpack_public_path__ + "a1af5ff96ad1e793848dc2bd07bbb100.png";